import {
  YEAR_LABEL,
  YEARS_LABEL,
  MONTH_LABEL,
  MONTHS_LABEL,
} from "../../constants/Dictionary";

export const IT_DATE_FORMAT = "DD/MM/YYYY";
export const EN_DATE_FORMAT = "YYYY-MM-DD";
export const IT_SHORT_DATE_FORMAT = "MM/YYYY";

export const timeDifference = (current: Date, previous: Date) => {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  let elapsed = current.getTime() - previous.getTime();
  if (elapsed < 0) {
    elapsed = 0;
  }

  if (elapsed < msPerMinute) {
    const time = Math.round(elapsed / 1000);
    return time + (time > 1 ? "s fa" : "s fa");
  } else if (elapsed < msPerHour) {
    const time = Math.round(elapsed / msPerMinute);
    return time + (time > 1 ? "m fa" : "m fa");
  } else if (elapsed < msPerDay) {
    const time = Math.round(elapsed / msPerHour);
    return time + (time > 1 ? "h fa" : "h fa");
  } else if (elapsed < msPerMonth) {
    const time = Math.round(elapsed / msPerDay);
    return time + (time > 1 ? "g fa" : "g fa");
  } else if (elapsed < msPerYear) {
    const time = Math.round(elapsed / msPerMonth);
    return time + (time > 1 ? "m fa" : "m fa");
  } else {
    const time = Math.round(elapsed / msPerYear);
    return time + (time > 1 ? "y fa" : "y fa");
  }
};

export const getYearsAndMonths = (months: number) => {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  let result = "";

  if (years === 0) {
    if (remainingMonths === 0) {
      result = `< 1 ${MONTH_LABEL.toLocaleLowerCase()}`;
    } else {
      result =
        `${remainingMonths} ${remainingMonths === 1 ? MONTH_LABEL : MONTHS_LABEL}`.toLowerCase();
    }
  } else {
    if (remainingMonths === 0) {
      result = `${years} ${years === 1 ? YEAR_LABEL : YEARS_LABEL}`;
    } else {
      result =
        `${years} ${years === 1 ? YEAR_LABEL : YEARS_LABEL} ${years > 0 ? "e" : ""} ${remainingMonths} ${remainingMonths === 1 ? MONTH_LABEL : MONTHS_LABEL}`.toLowerCase();
    }
  }

  return result.toLowerCase();
};

export const isMonthSameOrAfter = (a: Date, b: Date) =>
  a.getFullYear() > b.getFullYear() ||
  (a.getFullYear() === b.getFullYear() && a.getMonth() >= b.getMonth());
